import axios from "axios";
import { getTrackingUserId } from "./HelloRetailHelper";

const getHelloRetailConfig = (self) => {
	return self.$store.getters.serverData.helloRetailConfig.config;
};
const getHelloRetailUrl = (self) => {
	return self.$store.getters.serverData.helloRetailConfig.baseUrl;
};

const HelloRetailClient = {
	trackingUser: (self) => {
		const body ={
			...getHelloRetailConfig(self)
		};
		return axios(`${getHelloRetailUrl(self)}/serve/trackingUser`, {method: "POST", body});
	},
	pageView: (self, pageViewData) => {
		const data = {
			trackingUserId: getTrackingUserId(self.$store.getters),
			...getHelloRetailConfig(self),
			...pageViewData
		};
		return axios(`${getHelloRetailUrl(self)}/serve/collect/pageview`, {method: "POST", data});
	},
	clickTracking: (self, source) => {
		const data = {
			trackingUserId: getTrackingUserId(self.$store.getters),
			...getHelloRetailConfig(self),
			source
		};
		return axios(`${getHelloRetailUrl(self)}/serve/collect/click`, {method: "POST", data});
	},
	cartTracking: (self, cartData) => {
		const data =  {
			trackingUserId: getTrackingUserId(self.$store.getters),
			...getHelloRetailConfig(self),
			...cartData
		};
		return axios(`${getHelloRetailUrl(self)}/serve/collect/cart`, {method: "POST", data});
	},
	conversionTracking: (self, conversionData) => {
		const data = {
			trackingUserId: getTrackingUserId(self.$store.getters),
			...getHelloRetailConfig(self),
			...conversionData
		};
		return axios(`${getHelloRetailUrl(self)}/serve/collect/conversion`, {method: "POST", data});
	}
};

export default HelloRetailClient;